import React, { useEffect, useState } from "react";
import { DropBox } from "../../../components";
import { getAllCategory } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../../utils/environment";
import { useDispatch } from "react-redux";
import { setCategoryList } from "../../Category/redux/actions";

const lan = getLanguage();

const Index = ({ data, onChangeCategory }) => {
  const [language, setLanguage] = useState("");
  const [formData, setFormData] = useState({
    category: {
      key: "category",
      label: "Category",
      size: "lg",
      placeholder: "Select category",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();

  const fetchCategories = async () => {
    const updateForm = { ...formData };
    updateForm.category.loading = true;
    updateForm["category"].elementConfig.options = [];
    const response = await getAllCategory();
    if (response?.data) {
      let categoryList = await syncCategory(response.data);
      updateForm["category"].elementConfig.options = categoryList;
      updateForm.category.loading = false;
      dispatch(setCategoryList(response.data));

      setFormData(updateForm);
    }
  };

  const syncCategory = async (res) => {
    let categoryList = [];
    for (let category of res) {
      categoryList.push({
        id: category.category_id,
        key: category.name[data?.language || lan],
        value: category.category_id,
        displayValue: category.name[data?.language || lan],
      });
    }
    return categoryList;
  };

  useEffect(() => {
    if (formData.category.elementConfig.options.length === 0) {
      fetchCategories();
    }
  }, []);

  useEffect(() => {
    if (data && data.language && data.language !== language) {
      setLanguage(data.language);
      fetchCategories();
    }
  }, [data]);

  const updateNewsForm = { ...formData };

  return (
    <>
      <DropBox
        data={updateNewsForm.category}
        onChange={(e) => {
          const updateForm = { ...formData };
          updateForm["category"].value = e;
          setFormData(updateForm);
          console.log("Category Select Box:", e);
          onChangeCategory(e);
        }}
      />
    </>
  );
};

export default Index;
